import http from "../http-common";

class ExamenService {

    create(data) {
        return http.post("/examen",data);
    }

    get(id) {
        return http.get(`/examen/${id}`);
    }

    update(id, data) {
        return http.put(`/examen/${id}`, data);
    }

    eliminarExamen(id) {
        return http.delete(`/examen/${id}`);
    }
}

export default new ExamenService();